import * as React from 'react';

import { connect, Dispatch } from 'react-redux';

import ListProductionsView from 'list-addon-productions.view';
import { IAddOnsAppState } from '../../redux-state';
import { IAddOnsAppText } from '../../custom/classes/add-ons-text';
import { IAddOnProduction } from '../../custom/classes/production';
import { processAddons } from '../../../add-ons/redux-state/actions/add-ons-api.actions';
import { displayLoading } from '../../../add-ons/redux-state/actions/add-ons.actions';

// Resize Sensor will ensure the sticky sidebar is able to update itself when the content changes
import 'css-element-queries/src/ResizeSensor.js';
import { StickySidebarComponent } from '../../../../Static/javascript/Ace2/modules/sticky-sidebar-component';

interface IListProductionsExternalProps {
}

interface StateToProps {
    productions: Array<IAddOnProduction>;
    text: IAddOnsAppText;
    itemsToReserve: number;
    addOnsTotal: number;
    reserveFailed: boolean;
    loading: boolean;
}

interface DispatchToProps {
    reserveAddons: () => void;
    displayLoading: (enable: boolean) => void;
}

export type ListProductionsProps = IListProductionsExternalProps & StateToProps & DispatchToProps;
export class ListProductionsBase extends React.Component<ListProductionsProps, any> {
    constructor(props) {
        super(props);

        this.state = {
            stickyInstance: null
        }
    }

    componentDidMount() {
        this.stickyCart();
    }

    stickyCart() {
        if (this.state) {
            if (this.state.stickyInstance == null) {
                const fixedSubsSticky = new StickySidebarComponent(document.getElementById('miniCart'));
                this.setState({
                    stickyInstance: fixedSubsSticky.stickySidebar
                });
                // Needs to update after render is done
                window.requestAnimationFrame(() => {
                    this.state.stickyInstance.updateSticky();
                });
            }
            else {
                this.state.stickyInstance.updateSticky();
            }
        }
    }

    render() {
        return (
            <ListProductionsView {...this.props} />
        )
    }
}

function mapStateToProps(state: IAddOnsAppState, ownProps: IListProductionsExternalProps): StateToProps {
    const reserveRequests = state.addOns.reserveRequests;
    let itemsInCart = 0;

    if (!state.addOnsText.seatedAddon) {
        const selectedPerfs = reserveRequests.filter(req => req.priceTypeQuantity.size > 0 && req.zoneId > 0);
        itemsInCart = selectedPerfs.length;
    }
    else {
        itemsInCart = state.addOns.reserveRequests.length;
    }

    const addOnsTotal = reserveRequests.reduce((sum, value) => { return sum + value.total }, 0) + state.addOnsText.cartTotal;
    return {
        productions: state.addOns.addOnProductions,
        text: state.addOnsText,
        itemsToReserve: itemsInCart,
        addOnsTotal: addOnsTotal,
        reserveFailed: state.addOns.failedReserve.length > 0,
        loading: state.addOns.processing
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        reserveAddons: () => { dispatch(processAddons() as any); },
        displayLoading: (enable: boolean) => { dispatch(displayLoading(enable) as any) }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListProductionsBase);